import { ModuleWithProviders } from "@angular/core";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";

export const entityModuleImports: ModuleWithProviders<any>[] = [
	StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: false, connectInZone: true }),
];
